jQuery(document).ready(function ($) {

    $('.popup-famicord-overlay').each(function(ind, el) {
        const popupName = $(el).attr("id");
        $(el).addClass("show");
        $(el).find(".close-popup").click(function () {
            $("#"+popupName).removeClass("show");
        });
    });
});


// WEBPACK FOOTER //
// ./assets/js/popUp.js